import axios from "axios";
import { config } from "../../../../../enviroment";

export const forgotPasswordService={
    reset,
    forgotPassword
}

async function reset(username) {
    return await axios.post(config.urls.RESET, {
      email: username,
    });
  }
  
async function forgotPassword(username,action,sessionId,newPassword,customerNumber) {

  var body = {
    userName: action === "UPDATE_PASSWORD"?username:config.parameters.DPDC_PHONE_PREFIX+username,
    action: action,
    tenantCode: config.parameters.TENANT_CODE,
    customerNumber:customerNumber
  }
  if(action === "UPDATE_PASSWORD") {
    body.sessionId = sessionId;
    body.newPassword = newPassword;
    body.customerNumber=customerNumber
  }
  return new Promise((resolve, reject) => {
    axios
      .post(
        config.urls.FORGOT_PASSWORD,
        body,
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}